import React from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';

import LinearProgress from 'material-ui/LinearProgress';
import DetailView from '../Common/DetailView';
import { List } from 'material-ui/List';
import ListItem from '../LearningRecordStore/StatementListItem';

import IconPerson from 'material-ui/svg-icons/action/perm-identity';
import SettingsIcon from 'material-ui/svg-icons/action/settings';
import SkillIcon from 'material-ui/svg-icons/social/public';
import EnrolmentIcon from 'material-ui/svg-icons/social/school';

import UserStore from '../../stores/UserStore';
import UserActions from '../../actions/UserActionCreator';
import ActivityStore from '../../stores/ActivityStore';
import LRS from '../../utils/LRS.js';

import ROLES from '../../constants/Roles';
import buildContextMenu from '../Common/BuildContextMenu';
import { formatName } from '../../utils/StringUtils';


const style = {
    list: {
        paddingBottom: 0
    }
};

const UserActivity = React.createClass({

    getInitialState: function(){
        return {
            details: {
                id: '',
                fullName: '',
                title: '',
                firstName: '',
                lastName: '',
                initials: '',
                dateOfBirth: '',
                jobRole: '',
                username: '',
                email: '',
                visits: '',
                lastLogin : '',
                departments: [],
                userGroups: [],
                roles: [],
                managers: [],
            },
            activities: (<div><LinearProgress mode="indeterminate" /></div>),
            calendars: [],
            actions: [],
            menuItems: [
                {
                    link: '/dashboard/user/' + this.props.routeParams.id,
                    icon: <IconPerson />,
                    label: 'User profile',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    type: 'divider'
                },
                {
                    link: '/dashboard/courses/enrolments/user/' + this.props.routeParams.id,
                    icon: <EnrolmentIcon />,
                    label: 'Enrolments',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                },
                {
                    link: '/dashboard/user/' + this.props.routeParams.id + '/skills',
                    icon: <SkillIcon />,
                    label: 'Skills',
                },
                {
                    type: 'divider'
                },
                {
                    link: '/dashboard/user/' + this.props.routeParams.id + '/settings',
                    icon: <SettingsIcon />,
                    label: 'Settings',
                    condition: {
                        roles: [ROLES.ADMIN]
                    }
                }

            ],
            links: {
                back: '/dashboard/user/' + this.props.routeParams.id,
                edit: '',
            },
        }
    },

    componentDidMount: function(){
        UserStore.addChangeListener(this.onChange);
        UserActions.getById(this.props.routeParams.id);
        ActivityStore.addChangeListener(this.onActivityChange);
        LRS.getUserActivity(this.props.routeParams.id);

        this.setState({actions: buildContextMenu(this.state.menuItems, this.context.auth)});

    },

    componentWillUnmount: function() {
        UserStore.removeChangeListener(this.onChange);
        ActivityStore.removeChangeListener(this.onActivityChange);
    },

    render: function() {

        const fullName = formatName(this.state.details);

        return (

            <DetailView
                title={fullName}
                backButton={true}
                backTo={this.state.links.back}
                actions={this.state.actions}
            >
                <div className="cent-list-wrapper">
                    <List style={style.list} className='cent-list'>
                        {this.state.activities}
                    </List>
                </div>
            </DetailView>
        )
    },

    onChange: function(){
        const details = UserStore.getById(this.props.routeParams.id);
        if (details !== undefined) {
            let state = assign({}, this.state, {details: details});
            this.setState(state);
        }
    },

    onActivityChange: function() {
        const activities = ActivityStore.getByUser(this.props.routeParams.id);
        if (activities !== undefined) {
            let entries = activities
                .filter((e) => {
                    if (e !== undefined) {
                        const verb = e.verb.id.split('/').pop();
                        return verb === 'passed' || verb === 'failed';
                    }
                    return false;
                })
                .sort((a, b) => b.datetime - a.datetime )
                .map((e) => <ListItem statement={e} key={e.id} /> );
            this.setState({activities: entries});
        }
    },

});

UserActivity.contextTypes = {
    auth: PropTypes.object.isRequired
};

export default UserActivity;
